import { render, staticRenderFns } from "./DirectionDisplay.vue?vue&type=template&id=219e1898"
import script from "./DirectionDisplay.vue?vue&type=script&lang=js"
export * from "./DirectionDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports